import { Card, CardContent, Skeleton, PaneResponsiveCardGrid, cn } from '@yeshuman/sdk'

interface BoardSkeletonProps {
  view: 'kanban' | 'list'
  className?: string
}

export function ApplicantsBoardSkeleton({ view, className }: BoardSkeletonProps) {
  if (view === 'kanban') {
    return (
      <div
        className={cn(
          'flex gap-4 overflow-x-auto',
          className,
        )}
        aria-busy="true"
      >
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex h-full min-w-[280px] flex-col rounded-lg border border-border/40 bg-muted/10"
          >
            <div className="flex items-center justify-between border-b border-border/60 px-3 py-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-6" />
            </div>
            <div className="space-y-2 p-4">
              {[0, 1, 2].map((j) => (
                <Card key={j}>
                  <CardContent className="space-y-2">
                    <div className="flex items-start gap-3">
                      <Skeleton className="h-9 w-9 rounded-full" />
                      <div className="flex-1 space-y-1.5">
                        <Skeleton className="h-3.5 w-3/4" />
                        <Skeleton className="h-3 w-2/3" />
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <Skeleton className="h-3 w-12" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={cn('space-y-6', className)} aria-busy="true">
      {[0, 1].map((i) => (
        <div key={i} className="space-y-3">
          <Skeleton className="h-4 w-32" />
          <PaneResponsiveCardGrid className="gap-3">
            {[0, 1, 2].map((j) => (
              <Card key={j}>
                <CardContent className="space-y-2">
                  <div className="flex items-start gap-3">
                    <Skeleton className="h-9 w-9 rounded-full" />
                    <div className="flex-1 space-y-1.5">
                      <Skeleton className="h-3.5 w-3/4" />
                      <Skeleton className="h-3 w-2/3" />
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Skeleton className="h-3 w-12" />
                    <Skeleton className="h-3 w-16" />
                  </div>
                </CardContent>
              </Card>
            ))}
          </PaneResponsiveCardGrid>
        </div>
      ))}
    </div>
  )
}
